var $ = require('jquery');

$(document).ready(function() {
    $('.loyalty-links a').click(function(e) {
        e.preventDefault();
        $('.loyalty-links tbody').html('<tr><td colspan="4" style="text-align: center;"><img src="/images/loader.gif" /></td></tr>');

        $.ajax({
            url: $(this).attr('href'),
            success: function(html) {
                $("#loyalty").html(html);
            }
        });
    });
});
